// extracted by mini-css-extract-plugin
module.exports = {"icon":"order_icon_3W0xp"};